<template>
    <div class="menu-wrap">
        <a @click="handleMute" :class="{active:muted}" class="menu-item"><span class="material-icons" :class="{disabled: dummyAudio}">{{muted ? 'mic_off' : 'mic'}}</span></a>
        <a @click="handleVideo" :class="{active:hideVideo}" class="menu-item"><span class="material-icons" :class="{disabled: dummyVideo}">{{hideVideo ? 'videocam_off' : 'videocam'}}</span></a>
        <a @click="handleDeafen" :class="{active:deafen}" class="menu-item"><span class="material-icons">{{deafen ? 'volume_off' : 'volume_up'}}</span></a>
        <a @click="handleScreenShare" :class="{active:screenShare}" class="menu-item" v-if="canShareScreen"><span class="material-icons">screen_share</span></a>
        <a @click="handleChat" :class="{active: isChatOpen}" class="menu-item"><span class="material-icons">chat</span></a>
    </div>
</template>

<script>
export default {
    props: {
        muted: Boolean,
        hideVideo: Boolean,
        deafen: Boolean,
        screenShare: Boolean,
        canShareScreen: Boolean,
        dummyVideo: Boolean,
        dummyAudio: Boolean
    },
    methods: {
        handleMute () {
            if (this.dummyAudio) {
                return
            }
            this.$emit('mute', !this.muted)
        },
        handleVideo () {
            if (this.dummyVideo) {
                return
            }
            this.$emit('hide-video', !this.hideVideo)
        },
        handleDeafen () {
            this.$emit('deafen', !this.deafen)
        },
        handleScreenShare () {
            this.$emit('screen-share', !this.screenShare)
        },
        handleChat () {
            this.setChat(!this.isChatOpen)
        }
    }
}
</script>

<style lang="scss" scoped>
.menu-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    z-index: inherit;
    height: 100%;
    background: var(--main-color);
}
.menu-item {
    border-radius: 50%;
    background: rgb(167, 167, 167);
    color: var(--main-color);
    height: 48px;
    width: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin: 0 10px;
    .material-icons {
        font-size: 1.75rem;
        user-select: none;
        &.disabled {
            opacity: 0.7
        }
    }
    &.active {
        background: var(--secondary-color);
    }
}


</style>